import { isEmpty } from "./isEmpty"

type ConvertToLocaleParams = {
  amount: number
  currency_code: string
  minimumFractionDigits?: number
  maximumFractionDigits?: number
  locale?: string
  showSign?: boolean
}

const normalizeCurrencyCode = (code: string) => {
  if (code === "TL") return "TRY";
  return code;
};

export const convertToLocale = ({
  amount,
  currency_code,
  minimumFractionDigits,
  maximumFractionDigits,
  locale = "tr-TR",
  showSign = false,
}: ConvertToLocaleParams) => {
  return currency_code && !isEmpty(currency_code)
    ? new Intl.NumberFormat(locale, {
        style: "currency",
        currency: normalizeCurrencyCode(currency_code),
        minimumFractionDigits,
        maximumFractionDigits,
        signDisplay: showSign ? "always" : "auto",
      }).format(amount)
    : amount.toString()
}
